export default (props, vars) =>
  props?.['students'].findIndex(
    (s) => s.id === vars?.['usestateprofilepopupopened']?.['state']
  ) ===
  props?.['students'].length - 1
    ? 'hidden'
    : undefined;
